import { Vector3 } from "three";
import { BoneToVector } from "./index50.js";
import { getInnerLoadSide } from "./index225.js";
const _vectorA = new Vector3();
const _vectorB = new Vector3();
const _cross = new Vector3();
function getInnerMuscles(boneA, boneB) {
  BoneToVector(boneA, _vectorA);
  BoneToVector(boneB, _vectorB);
  const aFacesB = boneB.joints.includes(boneA.joints[1]);
  const bFacesA = boneA.joints.includes(boneB.joints[1]);
  const aAtBStart = boneA.joints.includes(boneB.joints[0]);
  const bAtAStart = boneB.joints.includes(boneA.joints[0]);
  if (aFacesB)
    _vectorA.negate();
  _cross.crossVectors(_vectorB, _vectorA);
  const aAtBRight = _cross.y < 0;
  if (aFacesB)
    _vectorA.negate();
  if (bFacesA)
    _vectorB.negate();
  _cross.crossVectors(_vectorA, _vectorB);
  const bAtARight = _cross.y < 0;
  const innerMuscleSideA = getInnerLoadSide(aFacesB, aAtBStart, aAtBRight);
  const innerMuscleSideB = getInnerLoadSide(bFacesA, bAtAStart, bAtARight);
  const muscles = [
    boneA.muscles.find((m) => m.side === innerMuscleSideA),
    boneB.muscles.find((m) => m.side === innerMuscleSideB)
  ];
  return muscles;
}
export {
  getInnerMuscles
};
//# sourceMappingURL=index226.js.map
